import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
    TableBody,
    TableCell,
    TableHead
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';


import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import {
    Add,
    Close, 
    Check, 
    Edit
} from 'material-ui-icons';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';

import axios from 'axios';
import moment from 'moment-timezone';
import tsl from '../../../tsl';
import Filter from '../Filter';

class RequestsList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			rowsPerPage: 10,
      page: 1,
		  total: 0,
			data: [],
      filter: null
		};
	}

	componentDidMount() {
		// this.loadEntities(1);
	}

	loadEntities(page) {
	  axios.get('/api/operator/requests', {
		  params: {
		    page,
        perPage: this.state.rowsPerPage,
        ...this.state.filter
      }
    })
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage = (e, page) => {
		this.loadEntities(page+1);	// paginator counts pages as indexes (starting 0)
	};

	getStartLocationName = (model) => {
	  if (model.pickup_point) {
      return model.pickup_point.title;
    }

    return tsl('not_specified');
  };

  getDestinationName = (model) => {
    if (model.drop_off_point) {
      return model.drop_off_point.title;
    }

    return tsl('not_specified');
  };

  createEditHandler = (model) => () => {
    this.props.history.push(`${this.props.match.url}/${model.id}`);
  };

  handleFilterChange = (filter) => {
    this.setState({
      filter
    }, () => this.loadEntities(this.state.page));
  };

  renderTimeRange = (timeFrom, timeTo) => {
    const startTime = moment(timeFrom);
    let endTime = timeTo;

    if (timeTo) {
      endTime = moment(timeTo);
      let endTimeFormat = 'lll';
      if (startTime.format('l') === endTime.format('l')) {
        // it's the same day, display time only from end time
        endTimeFormat = 'LT';
      }

      return `${startTime.format('lll')} - ${endTime.format(endTimeFormat)}`;
    }

    return startTime.format('lll');
  };

  render() {

    return (
      <div>
        <Filter
          onChange={this.handleFilterChange}
        />
        <Paper>
            <div className="flex-auto">
                <div className="table-responsive-material">
                    <List>
                        {this.state.data.map((model, index) => {
                            return (<div key={model.id}>
                                <ListItem button
                                    onClick={this.createEditHandler(model)}
                                >
                                    <Grid container spacing={8}>
                                        <Grid item xl={3} md={3} sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                          primary={
                                                            <div>
                                                            {`#${model.id} ${model.status.title}`}<br />
                                                            <span><i className="zmdi zmdi-email" />{' '}{moment(model.created_at).format('lll')}</span>
                                                            </div>
                                                          }
                                            />
                                        </Grid>

                                        <Grid item xl={3} md={3} sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                primary={
                                                  <div>
                                                    <span><i className="zmdi zmdi-account" />{' '}{model.first_name}{' '}{model.last_name}</span>
                                                    <br />
                                                    <span><i className="zmdi zmdi-airplane" />{' '}{model.aircraft_model && model.aircraft_model.name}</span>
                                                  </div>
                                                }
                                            />
                                        </Grid>

                                        <Grid item xl={3} md={3} sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                          primary={
                                                            <div>
                                                              <span><i className="zmdi zmdi-flight-takeoff text-success" />{' '}{this.getStartLocationName(model)}</span>
                                                              <br />
                                                              <span><i className="zmdi zmdi-flight-land text-info" />{' '}{this.getDestinationName(model)}</span>
                                                            </div>
                                                          }
                                            />
                                        </Grid>

                                        <Grid item xl={3} md={3} sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                primary={
                                                  <div>
                                                    <i className="zmdi zmdi-timer" />{' '}{this.renderTimeRange(model.time_from, model.is_time_range ? model.time_to : null)}
                                                  </div>
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </ListItem>
                                <Divider light />
                            </div>
                            );
                        }, this)}

                    </List>

                    <Table className="">
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.state.total}
                                    rowsPerPage={this.state.rowsPerPage}
                                    rowsPerPageOptions={[this.state.rowsPerPage]}
                                    page={this.state.page-1}
                                    onChangePage={this.handleChangePage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </div>
        </Paper>
      </div>
      );
  }
}

export default RequestsList;


// WEBPACK FOOTER //
// ./app/used/requests/routes/List.js